import { useCallback, useState, useMemo } from 'react';

const useToggle = (initialState = false): [boolean, { toggle: any; setToggleState: any; }] => {
    const [state, setState] = useState<boolean>(initialState);
    const toggle = useCallback((): void => setState(stateValue => !stateValue), []);
    const setToggleState = useCallback((value: boolean): void => setState(Boolean(value)), []);
    const setToggle = useMemo(() => ({ toggle, setToggleState }), [toggle, setToggleState]);

    return [state, setToggle];
};

export default useToggle;
